import styled, { css } from 'styled-components';

export const buttonPrimaryStyles = css`
  border: 0;
  -webkit-appearance: none;
  padding: 15px 25px;
  margin: 32px 0;
  border-radius: ${props => props.theme.buttonPrimaryBorderRadius};
  font-size: ${props => props.theme.fontSizePrimary};
  font-family: ${props => props.theme.fontFamilyButton};
  text-align: center;
  color: white;
  background-color: ${props => props.theme.buttonPrimaryBackgroundColor};
  text-decoration: none !important;
  line-height: 1;
  cursor: pointer;
  display: block;
  
  :focus {
    box-shadow: ${props => props.theme.buttonPrimaryBoxShadowFocus};
    outline: none;
  }
`;

export const PrimaryButton = styled.button`
  ${buttonPrimaryStyles};
`;

// TODO deprecate this primaryCare secondary button in favour of the one that can be used for both products
export const SecondaryButton = styled.button`
  margin: 0.6em 0;
  padding: 5px 15px;
  font-size: ${props => props.theme.fontSizePrimary};
  font-family: ${props => props.theme.fontFamilyButton};
  color: ${props => props.theme.buttonPrimaryBackgroundColor};
  background-color: white;
  border: 1px solid ${props => props.theme.buttonPrimaryBackgroundColor};
  border-radius: 8px;
  cursor: pointer;
`;
